const state = {
  lastAccessedDate: new Date(),
  stepIndex: 0,
};

export default state;
